import Vue from 'vue'

const months = [ 'Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec' ]
const days = ['Ne','Po','Út','St','Čt','Pá','So']

Vue.filter('date', timestamp => {
  const date = new Date(timestamp*1000)
  return months[date.getMonth()] + ' ' + date.getFullYear()
})

Vue.filter('longdate', timestamp => {
  const date = new Date(parseInt(timestamp) * 1000)
  const d = date.getDate()<10 ? '0'+date.getDate() : date.getDate()
  const m = (date.getMonth()+1)<10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1)
  const y = date.getFullYear()
  return `${d}.${m}.${y}`
})

Vue.filter('daydate', timestamp => {
  const date = new Date(parseInt(timestamp) * 1000)
  const day = days[date.getDay()]
  const d = date.getDate()<10 ? '0'+date.getDate() : date.getDate()
  const m = (date.getMonth()+1)<10 ? '0'+(date.getMonth()+1) : (date.getMonth()+1)
  const y = date.getFullYear()
  return `${day} ${d}.${m}`
})

Vue.filter('time', timestamp => {
  const date = new Date(parseInt(timestamp) * 1000)
  const hh = (date.getHours())<10 ? '0'+(date.getHours()) : (date.getHours())
  const mm = (date.getMinutes())<10 ? '0'+(date.getMinutes()) : (date.getMinutes())
  const ss = (date.getSeconds()<10 ? '0'+(date.getSeconds()) : date.getSeconds())
  return `${hh}:${mm}:${ss}`
  return new Date(parseInt(timestamp) * 1000).toLocaleTimeString('cs')
})

Vue.filter('timeshort', timestamp => {
  const date = new Date(parseInt(timestamp) * 1000)
  const hh = (date.getHours())<10 ? '0'+(date.getHours()) : (date.getHours())
  const mm = (date.getMinutes())<10 ? '0'+(date.getMinutes()) : (date.getMinutes())
  const ss = (date.getSeconds()<10 ? '0'+(date.getSeconds()) : date.getSeconds())
  return `${hh}:${mm}`
  return new Date(parseInt(timestamp) * 1000).toLocaleTimeString('cs')
})

Vue.filter('grams', grams => {
  var grams = isNaN(grams) ? '' :  Number(grams).toLocaleString() + 'g'
  return grams
})

Vue.filter('gbp', gbp => {
  if (!gbp) return ''
  return `£${gbp}`
})

Vue.filter('eur', eur => {
  if (!eur) return ''
  return `${eur} €`
})

Vue.filter('czk', czk => {
  if (!czk) return ''
  return `${czk} Kč`
})

Vue.filter('float', num => {
  if (!num) return ''
  return parseFloat(num)
})

Vue.filter('int', num => {
  if (!num || num == '.000') return ''
  return parseInt(num)
})

Vue.filter('round', num => {
  if (!num) return num
  return num.toLocaleString('cs-CZ', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).replace('.', ',')
})

Vue.filter('format', num => {
  return Number(num).toLocaleString()
})

Vue.filter('per', num => {
  return `${num}%`
})



// WEBPACK FOOTER //
// ./src/filters.js